import { getWordPressProps, WordPressTemplate } from "@faustwp/core";
import type { GetStaticPropsContext } from "next";

import type { PageProps } from "@/types";
import { GLOBAL_REVALIDATE } from "@/constants/revalidate";

export default function Page(props: PageProps) {
  return <WordPressTemplate {...props} />;
}

export function getStaticProps(ctx: GetStaticPropsContext) {
  return getWordPressProps({ ctx, revalidate: GLOBAL_REVALIDATE });
}
